// Keys stored as plain text rather than inside the encoded blob.
const PLAINTEXT_KEYS = ["longitude", "latitude", "i18nextLng", "lang", "currentStep"]

/**
 * Reads a field out of the encoded `user_info` blob in localStorage.
 *
 * Every other key on the origin is base64 too, so they are all decoded to find
 * it. Anything that fails to decode is skipped: another app served from the
 * same origin (a different port on localhost, say) leaves plain-text keys
 * behind, and `atob` throwing on one of those used to propagate out of
 * `RequiredAuth` during render — React unmounted the route into the error
 * boundary, so the guard never redirected and the page came up blank.
 */
const userInfo = (information?: any) => {
    if (localStorage.length === 0) return ""

    const decodedData: any = {}

    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        if (key === null) continue

        const rawValue = localStorage.getItem(key)

        if (PLAINTEXT_KEYS.includes(key)) {
            decodedData[key] = rawValue
            continue
        }

        try {
            decodedData[window.atob(key)] = JSON.parse(window.atob(`${rawValue}`))
        } catch {
            // Not ours — leave it alone.
            continue
        }
    }

    return decodedData?.user_info?.[information]
}

export default userInfo
